import Header from "../components/Header";
import Fondo2 from "../assets/neg.png"
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import IMG1 from "../assets/riendo.png";
import IMG2 from "../assets/juridico.png";
import IMG3 from "../assets/calculando.png";
import Footer from "../components/Footer";

const Services = () => {
    const navigate = useNavigate();
    const areas = [
        {
            title: "Asesoría Administrativa",
            text:"Tenemos la capacidad y la experiencia para asesorarlo en todas las necesidades de su empresa, relacionado con los recursos (internos y externos) que pueden afectar al funcionamiento de cualquier entidad, tanto en su estructura y definición, como en su correcto funcionamiento. Trámites, licencias, recursos humanos.",
            img:IMG1
        },
        {
            title: "Asesoría Jurídica",
            text:"Tenemos la capacidad y la experiencia para asesorarlo en todas las necesidades de su empresa, permítanos ayudarlo a satisfacer los diversos requerimientos legales de su negocio, incluyendo la resolución de cualquier litigio, en el que usted o su empresa sean parte, ya sea frente a particulares o autoridades.Nuestra meta es la excelencia, tanto en el desempeño como en los resultados, y la mejor práctica legal",
            img:IMG2
        },
        {
            title: "Asesoría Contable",
            text:"Atendemos personas físicas y morales; elaboramos la contabilidad con base en sus necesidades de información. Le ofrecemos un servicio personalizado que le dará respuestas rápidas y precisas; además podemos ayudarle en la elaboración de sus nóminas; le ofrecemos una contabilidad confiable para el cálculo de sus impuestos.",
            img:IMG3
        },
    ];
    return (
        <>
            <Header/>
            <div>
                <div
                    className="w-full h-[60vh] relative bg-cover bg-top bg-no-repeat flex items-center justify-left p-16"
                    style={{ backgroundImage: `url(${Fondo2})` }}
                >
                    <div className="absolute top-0 left-0 w-full h-full bg-[#533144]/70"></div>
                    <h1 className="text-5xl text-white font-bold z-40">Área de práctica</h1>
                </div>
            {areas.map((a)=>(
                <div className="w-full h-auto md:h-[75vh] grid grid-cols-1 md:grid-cols-2 md:px-36">
            <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="w-full h-[55vh] md:h-full bg-contain bg-center bg-no-repeat flex items-center justify-start"
                style={{ backgroundImage: `url(${a.img})` }} 
            />
            <div className="relative w-full h-full flex flex-col justify-center text-left px-4 md:px-0">
                <div className="bg-estra p-12 text-white md:absolute md:-left-16 ">
                <h1 className="font-bold text-4xl">{a.title}</h1>
                    <p className="text-lg text-justify">
                        {a.text}
                    </p>
                    <button className="text-white bg-trasparent border border-white p-2 px-4 rounded-full mx-auto" onClick={()=>navigate("/contact")}>
                        Concertar una cita
                    </button>
                </div>
            </div>
        </div>
        ))}
            </div>
            <Footer/>
        </>
    );
};

export default Services;